export default "__VITE_ASSET__16350188__"